import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      const res = await api.post("/auth/login", { email, password });
      setToken(res.data.token);
      localStorage.setItem("labor_user", JSON.stringify({ name: res.data.name, email: res.data.email, role: res.data.role }));
      nav("/admin/dashboard");
    } catch (e) {
      setError(e.response?.data?.detail || "Errore di accesso");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="text-xs uppercase tracking-widest text-labor-muted">Area riservata</div>
      <h1 className="font-display text-4xl mt-2 mb-8">Accesso staff</h1>
      <form onSubmit={submit} className="paper-card p-8 space-y-4">
        <div>
          <label className="text-sm font-medium">Email</label>
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full mt-1 px-3 py-3 border border-labor-border focus:outline-none focus:ring-2 focus:ring-labor-terracotta text-lg" />
        </div>
        <div>
          <label className="text-sm font-medium">Password</label>
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full mt-1 px-3 py-3 border border-labor-border focus:outline-none focus:ring-2 focus:ring-labor-terracotta text-lg" />
        </div>
        {error && <div className="text-red-700 text-sm bg-red-50 p-3 border border-red-200">{error}</div>}
        <button disabled={loading} type="submit" data-testid="admin-login-btn" className="w-full olive-btn py-3.5 font-semibold flex items-center justify-center gap-2">
          {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Accesso…</> : "Accedi"}
        </button>
      </form>
    </div>
  );
}
